import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';

@Directive({
    selector: '[libValueOfTheBasket]',
    standalone: false
})
export class ValueOfTheBasketDirective extends AliveState implements OnInit {
  ref: HTMLElement;
  recentValue = '';

  @Input() set libValueOfTheBasket(value) {
    console.log(value);
    this.recentValue = value;
    if (this.ref) {
      this.ref.innerText = value;
    }
  }

  constructor(private elementRef: ElementRef<HTMLElement>) {
    super();
  }

  ngOnInit() {
    console.log(this.elementRef.nativeElement.style.position);
    if (
      !['relative', 'fixed', 'absolute'].includes(
        getComputedStyle(this.elementRef.nativeElement).position
      )
    ) {
      this.elementRef.nativeElement.style.position = 'relative';
    }
    this.ref = document.createElement('span');
    this.ref.innerText = this.recentValue;
    this.ref.style.position = 'absolute';
    this.ref.style.right = '-50%';
    this.ref.style.top = '-10px';
    this.ref.style.backgroundColor = 'white';
    this.ref.style.padding = '5px 5px';
    this.ref.style.borderRadius = '5px';
    this.ref.style.color = '#333333';
    this.ref.style.fontSize = '12px';
    this.ref.style.boxShadow =
      '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)';
    this.ref.style.lineHeight = '12px';
    this.ref.style.fontWeight = 'normal';
    this.elementRef.nativeElement.append(this.ref);
  }
}
